import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import Orangelogo from "../../assets/images/Orangelogo.png";
import Knowmorebtn from "../../components/button/Knowmorebtn";
import ReactPlayer from "react-player";
import bgCircle from "../../assets/images/BgCircle.png";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import video from "../../assets/video/whatwedo.mp4";

const Whatwedo = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayClick = () => {
    setIsPlaying(!isPlaying);
  };

  return (
    <Box
      sx={{
        maxWidth: "1440px",
        margin: "0 auto",
        display: "flex",
        flexDirection: { xs: "column-reverse", sm: "row" },
        alignItems: "center",
        padding: {
          xs: "2rem 1.5rem",
          sm: "6rem 3rem 1rem 3rem",
          md: "4rem 3rem",
        },
        gap: { xs: "2rem", sm: "2.5rem", md: "6rem" },
      }}
    >
      {/* Video Section */}
      <Box sx={{ position: "relative", width: { xs: "100%", sm: "48%" } }}>
        {/* Background Circle */}

        {/* Video Player */}
        <Box
          sx={{
            position: "relative",
            width: { xs: "100%", sm: "100%", lg: "85%" },
            borderRadius: "15px",
            overflow: "hidden",
            marginTop: { xs: "0px", sm: "100px" },
            border: "5px solid rgba(255, 102, 0, 1)",
            boxShadow: "0 4px 8px rgba(255, 102, 0, 0.1)",
            "&::before": {
              content: '""',
              display: "block",
              paddingTop: "56.25%",
            },
          }}
        >
          <ReactPlayer
            url={video}
            playing={isPlaying}
            controls={isPlaying}
            width="100%"
            height="100%"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
            }}
            onPause={() => setIsPlaying(false)}
            onEnded={() => setIsPlaying(false)}
          />
          {/* Play Icon Overlay */}
          {!isPlaying && (
            <Box
              onClick={handlePlayClick}
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 1,
                backgroundColor: "rgba(255, 102, 0, 0.9)",
                borderRadius: "50%",
                width: "60px",
                height: "60px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "rgba(255, 102, 0, 1)",
                  transform: "translate(-50%, -50%) scale(1.1)",
                },
              }}
            >
              <PlayArrowIcon
                sx={{
                  color: "white",
                  fontSize: "2.5rem",
                }}
              />
            </Box>
          )}
        </Box>
      </Box>

      {/* Text Section */}
      <Box
        sx={{
          width: { xs: "100%", sm: "50%" },
          textAlign: "left",
          paddingTop: { xs: "8rem", sm: "3rem" },
          display: "flex",
          flexDirection: "column",
          justifyContent: { xs: "flex-start", sm: "center" },
          height: { xs: "auto", sm: "100%" },
          alignSelf: { xs: "flex-start", sm: "center" },
        }}
      >
        <Box
          sx={{
            width: "4rem",
            marginTop: { xs: "2rem", sm: "4rem" },
          }}
        >
          <img src={Orangelogo} alt="logo" width="100%" />
        </Box>
        <Typography
          sx={{
            color: "#232325",
            fontFamily: "Montserrat",
            fontSize: { xs: "0.8rem", sm: "1rem" },
            fontWeight: 400,
            marginTop: "0.8rem",
          }}
        >
          WHAT WE DO
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Montserrat",
            fontSize: { xs: "1.4rem", sm: "1.6rem" },
            fontWeight: 500,
            marginTop: "1rem",
          }}
        >
          We Provide <br />
          <span style={{ color: "rgba(255, 102, 0, 1)" }}>
            Tailor-made Solutions
          </span>{" "}
          <br />
          for Your Business Questions
        </Typography>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: "1rem",
            marginTop: "1rem",
            color: "gray",
          }}
        >
          Empowering Decisions with Data-Driven Intelligence for Smarter
          Strategies & Growth
        </Typography>
        <Box sx={{ marginTop: "1.5rem" }}>
          <Knowmorebtn content="Read More" link="/aboutus" />
        </Box>
      </Box>
    </Box>
  );
};

export default Whatwedo;
